// extracted by mini-css-extract-plugin
export var bg = "index-module--bg--4ba7f";
export var container = "index-module--container--e6852";
export var footer = "index-module--footer--8aefb";
export var footerLeft = "index-module--footer-left--5bbd4";
export var footerRight = "index-module--footer-right--a2e05";
export var isInited = "index-module--isInited--9c8ab";
export var loading = "index-module--loading--c1ac4";